var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTik(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_21",
    "data-name": "Exclusion 21",
    d: "M-8591,7706a6.007,6.007,0,0,1-6-6,6.007,6.007,0,0,1,6-6,6.007,6.007,0,0,1,6,6A6.007,6.007,0,0,1-8591,7706Zm-3.017-6.044h0l-.71.759,2.41,2.25.218.2a.658.658,0,0,0,.321.084.652.652,0,0,0,.36-.108l4.146-5.662-.81-.729-3.819,5.178-2.116-1.972Z",
    transform: "translate(8597 -7694)",
    fill: "#4ca579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTik);
export default __webpack_public_path__ + "static/media/GreenTik.c81a8228.svg";
export { ForwardRef as ReactComponent };